"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;

var React = _interopRequireWildcard(require("react"));

var _FormFieldWrapper = _interopRequireDefault(require("../FormFieldWrapper/FormFieldWrapper"));

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _checkboxConfig = require("./checkboxConfig");

var _types = require("../../types");

var _validation = require("../../types/validation");

var _requiredIndicator = require("../../utils/requiredIndicator");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var CheckboxDefinition = _flowRuntime["default"].tdz(function () {
  return _checkboxConfig.CheckboxDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("checkbox", _flowRuntime["default"].ref(CheckboxDefinition)), _flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true), _flowRuntime["default"].property("noOptionalLabel", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("onChange", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())), true)));

var CheckboxProps = _flowRuntime["default"].type("CheckboxProps", _flowRuntime["default"].object(_flowRuntime["default"].property("checkbox", _flowRuntime["default"].ref(CheckboxDefinition)), _flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("input", _flowRuntime["default"].object()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]())));

var Checkbox = function Checkbox(_arg) {
  var checkbox = _arg.checkbox,
      disabled = _arg.disabled,
      input = _arg.input,
      inputStyle = _arg.inputStyle,
      isRequired = _arg.isRequired;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FieldLabel["default"], {
    field: checkbox,
    isRequired: isRequired
  }), checkbox.items && checkbox.items.map(function (item) {
    return /*#__PURE__*/React.createElement("label", {
      key: item.key,
      htmlFor: "".concat(input.name),
      className: inputStyle.controlClass
    }, /*#__PURE__*/React.createElement("input", Object.assign({}, input, {
      checked: input.value,
      disabled: disabled,
      key: item.key,
      id: input.name,
      type: checkbox.type,
      className: inputStyle.indicatorClass
    })), /*#__PURE__*/React.createElement("span", {
      className: "description" // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: "".concat(item.label || item.key).concat((0, _requiredIndicator.requiredIndicator)(isRequired))
      }
    }));
  }));
};

exports.Checkbox = Checkbox;
Checkbox.defaultProps = {
  disabled: false
};

var RFCheckbox = function RFCheckbox(_arg2) {
  var checkbox = _arg2.checkbox,
      disabled = _arg2.disabled,
      inheritedFieldValidation = _arg2.inheritedFieldValidation,
      onChange = _arg2.onChange,
      noOptionalLabel = _arg2.noOptionalLabel;
  return /*#__PURE__*/React.createElement(_FormFieldWrapper["default"], {
    field: checkbox,
    renderField: function renderField(_ref) {
      var input = _ref.input,
          inputStyle = _ref.inputStyle,
          isRequired = _ref.isRequired;
      return /*#__PURE__*/React.createElement(Checkbox, {
        checkbox: checkbox,
        disabled: disabled,
        input: input,
        inputStyle: inputStyle,
        isRequired: noOptionalLabel ? true : isRequired
      });
    },
    inheritedFieldValidation: inheritedFieldValidation,
    onChange: onChange
  });
};

RFCheckbox.defaultProps = {
  disabled: false,
  inheritedFieldValidation: [],
  onChange: undefined,
  noOptionalLabel: false
};
var _default = RFCheckbox;
exports["default"] = _default;